import axios from "axios";
import API from "../api/axios.js";


export const getReview = async (applicationId) => {
    const response = await API.get(`/application/${applicationId}/review`);
    return response.data;
};

export const saveEvaluation = async (applicationId, data) => {
    await API.put(`/application/${applicationId}/evaluation`, data);
};

export const verifyApplication = async (applicationId) => {
    await API.post(`/application/${applicationId}/verify`);
};

export const submitEvaluation = async (applicationId) => {
    await API.post(`/application/${applicationId}/submit`);
};